module.exports = __webpack_public_path__ + "img/size_1_4.b022bef6.png";